import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useNavigate } from "react-router-dom";

interface tabProps {
    params: any;
    selectedIndex: number;
}
export default function ServiceGroupTabs(props: tabProps) {
    const navigate = useNavigate();
    const handleChangeTabs = (tabId: number) => {
        if (tabId === 0) navigate(`/service-group/${props.params?.id}`);
        else if (tabId === 1) navigate(`/service-group/assign/service/${props.params?.id}`);
        else if (tabId === 2) navigate(`/service-group/assign/technician/${props.params?.id}`);
    }
    const tabs = [
        { id: 0, title: `edit`, child: <></> },
        { id: 1, title: `service`, child: <></> },
        { id: 2, title: `Technician`, child: <></> },
    ];
    const disableTabs = tabs.map(tab => tab.id).filter(tabId => {
        switch (tabId) {
            case 0:
                return !checkPrivileges('ROLE_SERVICEGROUP_UPDATE');
            case 1:
                return !checkPrivileges('ROLE_SERVICEGROUP_SERVICE_ASSIGN') && !checkPrivileges('ROLE_SERVICEGROUP_SERVICE_UNASSIGN');
            case 2:
                return !checkPrivileges('ROLE_SERVICEGROUP_TECHNICIAN_ASSIGN') && !checkPrivileges('ROLE_SERVICEGROUP_TECHNICIAN_UNASSIGN');
            default:
                return false;
        }
    });

    return (<>
        <VerticalTabs tabs={tabs} selectedIndex={props.selectedIndex} handleChangeTabs={handleChangeTabs} disableTabNo={disableTabs} />
    </>);
}